import React, { useContext, useState } from "react";
import { SignInBtn } from "../../components";
import { UserContext } from "../../context/useUser";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import VideocamIcon from "@material-ui/icons/Videocam";
import { Box, CircularProgress } from "@material-ui/core";
import { fb, storage, db } from "../../firebase";
import { toast } from "react-toastify";
import "./style.css";

const CreatePost = () => {
  const { user } = useContext(UserContext).user;
  const [postText, setPostText] = useState("");
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [imageProgress, setImageProgress] = useState(0);
  const [videoProgress, setVideoProgress] = useState(0);

  const validMessage = (m) => m && m.replace(/\s/g, "").length;

  const notification = (text) => {
    const raisetoast = (
      <p style={{ fontWeight: "700", color: "Black", fontSize: "1.4rem" }}>
        {text}
      </p>
    );
    toast(raisetoast);
  };

  const progressWithLabel = (progress) => {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" value={progress} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <p style={{ fontSize: "1.2rem" }}> {progress}% </p>
        </Box>
      </Box>
    );
  };

  const handleImage = (e) => {
    if (e.target.files[0]) {
      const maxAllowedSize = 1 * 1024 * 1024;
      if (e.target.files[0].size < maxAllowedSize) {
        setImage(e.target.files[0]);
        const imageSrc = URL.createObjectURL(e.target.files[0]);
        const image = document.getElementById("imagePreview");
        const preview = document.getElementById("imagePreview-wrap");
        image.src = imageSrc;
        preview.style.display = "flex";
      } else {
        notification("Image Size Should be Less than 1 MB");
      }
    }
  };

  const removeImage = () => {
    const image = document.getElementById("imagePreview");
    const preview = document.getElementById("imagePreview-wrap");
    image.src = "";
    preview.style.display = "none";
    setImage(null);
  };

  const handleVideo = (e) => {
    if (e.target.files[0]) {
      const maxAllowedSize = 10 * 1024 * 1024;
      if (e.target.files[0].size < maxAllowedSize) {
        setVideo(e.target.files[0]);
        const videoSrc = URL.createObjectURL(e.target.files[0]);
        const video = document.getElementById("videoPreview");
        const preview = document.getElementById("videoPreview-wrap");
        video.src = videoSrc;
        preview.style.display = "flex";
      } else {
        notification("Video Size Should be Less than 10 MB");
      }
    }
  };

  const removeVideo = () => {
    const video = document.getElementById("videoPreview");
    const preview = document.getElementById("videoPreview-wrap");
    video.src = "";
    preview.style.display = "none";
    setVideo(null);
  };

  const handlePost = async () => {
    const docId = user.uid + user.lastLoginAt + Date.now();

    if (image || video) {
      db.collection("posts").doc(docId).set({});
      if (image) {
        const imageName = user.uid + Date.now();
        const uploadTask = storage.ref(`images/${imageName}.jpg`).put(image);
        await uploadTask.on(
          "state_change",
          (snapshot) => {
            const prog = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setImageProgress(prog);
          },
          (error) => {
            console.log("Some Error Ocuured while Posting");
          },
          () => {
            storage
              .ref("images")
              .child(`${imageName}.jpg`)
              .getDownloadURL()
              .then((imageUrl) => {
                db.collection("posts").doc(docId).update({
                  text: postText,
                  image: imageUrl,
                  userName: user.displayName,
                  userEmail: user.email,
                  userImage: user.photoURL,
                  timestamp: fb.firestore.FieldValue.serverTimestamp(),
                });
                setImageProgress(0);
              });
          }
        );
        const imagePreview = document.getElementById("imagePreview-wrap");
        imagePreview.style.display = "none";
      }

      if (video) {
        const videoName = user.uid + Date.now();
        const uploadTask = storage.ref(`videos/${videoName}.mp4`).put(video);
        await uploadTask.on(
          "state_change",
          (snapshot) => {
            const prog = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setVideoProgress(prog);
          },
          (error) => {
            console.log("Some Error Ocuured while Posting");
          },
          () => {
            storage
              .ref("videos")
              .child(`${videoName}.mp4`)
              .getDownloadURL()
              .then((videoUrl) => {
                db.collection("posts").doc(docId).update({
                  text: postText,
                  video: videoUrl,
                  userName: user.displayName,
                  userEmail: user.email,
                  userImage: user.photoURL,
                  timestamp: fb.firestore.FieldValue.serverTimestamp(),
                });
                setVideoProgress(0);
              });
          }
        );
        const videoPreview = document.getElementById("videoPreview-wrap");
        videoPreview.style.display = "none";
      }
    } else {
      if (validMessage(postText)) {
        db.collection("posts").doc(docId).set({
          text: postText,
          userName: user.displayName,
          userEmail: user.email,
          userImage: user.photoURL,
          timestamp: fb.firestore.FieldValue.serverTimestamp(),
        });
        setPostText("");
      } else notification("Cannot Create an empty Post");
    }
    setPostText("");
  };

  const loggedIn = (
    <div className="createPost__loggedIn">
      <h3>Create a Post</h3>
      <div className="createPost__box">
        <textarea
          rows="1"
          cols="100"
          className="postText"
          value={postText}
          placeholder="Write Something ..."
          onChange={(e) => setPostText(e.target.value)}
        />
        <div className="preview">
          <div className="preview-wrap" id="imagePreview-wrap">
            <button className="preview-btn" onClick={removeImage}>
              X
            </button>
            <img id="imagePreview" src="" alt="selected" />
          </div>
          <div className="preview-wrap" id="videoPreview-wrap">
            <button className="preview-btn" onClick={removeVideo}>
              X
            </button>
            <video src="" controls id="videoPreview" type="video/mp4"></video>{" "}
          </div>
        </div>
      </div>
      <div className="createPost__options">
        <div className="postFileUpload">
          <div className="postImageUpload">
            <label htmlFor="image">
              <AddAPhotoIcon className="addImage" />
            </label>

            <input
              id="image"
              hidden
              type="file"
              accept="image/*"
              onChange={handleImage}
            />
          </div>
          {imageProgress !== 0 && (
            <span className="showProgress">
              {progressWithLabel(imageProgress)}
            </span>
          )}
          <div className="postVideoUpload">
            <label htmlFor="video">
              <VideocamIcon className="addVideo" />
            </label>
            <input
              id="video"
              hidden
              type="file"
              accept="video/mp4"
              onChange={handleVideo}
            />
          </div>
          {videoProgress !== 0 && (
            <span className="showProgress">
              {progressWithLabel(videoProgress)}
            </span>
          )}
        </div>
        {videoProgress !== 0 || imageProgress !== 0 ? (
          <CircularProgress />
        ) : (
          <button className="postIt" onClick={handlePost}>
            {" "}
            Post{" "}
          </button>
        )}
      </div>
    </div>
  );

  const noUser = (
    <div className="createPost__noUser">
      <SignInBtn /> <p style={{ marginLeft: "1rem" }}>to Post and Comment</p>
    </div>
  );

  return <div className="createPost">{user ? loggedIn : noUser}</div>;
};

export default CreatePost;
